// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gc-0";